/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Datetimeafteraspect8Inputs */

const de__class_datetimeafteraspect8 = /** @type {(inputs: _Class_Datetimeafteraspect8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nach Datum`)
};

/**

* @param {_Class_Datetimeafteraspect8Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_datetimeafteraspect8 = /** @type {((inputs?: _Class_Datetimeafteraspect8Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Datetimeafteraspect8Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_datetimeafteraspect8(inputs)
});
export { _class_datetimeafteraspect8 as "_class_DateTimeAFTERAspect" }